<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange" />
      <div class="text-center mx-auto my-2">
        <b-button variant="outline-primary" @click="addFlash">
          <div v-if="!subsection.file">
            <em class="fa fa-plus mr-1"></em> Добавить flash
          </div>
          <div v-else>
            <em class="fas fa-pen mr-1"></em> Изменить flash
          </div>
        </b-button>
      </div>
      <v-modal-files-upload wrkspcType="swf"></v-modal-files-upload>
    </div>
    <div class="flash-object w-75 mx-auto" v-if="subsection.file && noUpdateFiles">
      <b-card>
        <object width="100%" height="100%">
          <param name="movie" :value="'/api/files/' + subsection.file.physicalName">
          <embed :src="'/api/files/' + subsection.file.physicalName" width="100%" height="100%">
        </object>
      </b-card>
    </div>
    <div v-if="!isEditMode">
      <div class="text-center my-3" v-if="!isTestReviewMode">
        <b-button variant="primary" @click="sendAnswers">
          {{isTriedToAnswer ? 'Ответить ещё раз' : 'Ответить'}}
        </b-button>
      </div>
      <div v-else>
        <h5>Ответ ученика</h5>
        <b-form-input disabled :value="studentAnswer"></b-form-input>
        <h5 class="mt-2">Правильный ответ</h5>
        <b-form-input disabled :value="correctAnswer"></b-form-input>
      </div>
      <div class="mt-3" v-html="editedText"></div>
    </div>
    <div v-else>
      <h4>Ответы</h4>
      <b-input-group v-b-tooltip.hover
         title="Выполните нужные действия в flash, затем нажмите на кнопку 'Обновить ответ'.">
        <b-form-input id="answers-for-flash" disabled
          :value="(subsection.qstruct) ? subsection.qstruct.answer : ''"
          placeholder="Выполните нужные действия в flash, затем нажмите на кнопку справа."/>
        <b-input-group-append>
          <b-button variant="primary" @click="onAnswersChange">Обновить ответ</b-button>
        </b-input-group-append>
      </b-input-group>
        <h4 class="mt-3">Текст</h4>
        <wysiwyg-text-editor dataType="subSectionText" />
    </div>
    <b-input id="testInput" hidden disabled></b-input>
    <div>
      <hr noshade>
      <h5>Справка по Flash</h5>
      <div>
        <a href="https://helpx.adobe.com/ru/flash-player.html" target="_blank"><b-alert show>Нажмите для перехода по ссылке</b-alert></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')

export default {
  name: 'FlashTestSubSection',
  components: {
    VModalFilesUpload,
    WysiwygTextEditor
  },
  mixins: [ContentMixin, SubsectionMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection',
      isTestingMode: 'test/isTestingMode',
      test: 'test/getTest',
      progress: 'test/getProgress',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      solvedByStudent: 'educationStudentsManagement/getSolvedByStudent'
    }),
    onUpdateFlash() {
      return (this.subsection) ? this.subsection.file : null
    }
  },
  data() {
    return {
      isTriedToAnswer: false,
      noUpdateFiles: true,
      currentFlash: null,
      currentUrl: null,
      editedText: '',
      studentAnswer: null,
      correctAnswer: null
    }
  },
  created() {
    this.updateSubsection()
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  watch: {
    subsection() {
      this.isTriedToAnswer = false
      document.getElementById('testInput').value = ''
      this.updateSubsection()
    },
    onUpdateFlash() {
      this.noUpdateFiles = !this.noUpdateFiles
      if (this.$route.path === this.currentUrl && (this.currentFlash
      !== (this.subsection) ? this.subsection.file : null)) {
        this.updateUpdater()
        this.setSubsectionAnswer('')
        document.getElementById('testInput').value = ''
      }
      this.currentFlash = null
      this.currentUrl = null
      this.$nextTick(() => {
        this.noUpdateFiles = !this.noUpdateFiles
      })
    }
  },
  methods: {
    updateSubsection() {
      this.studentAnswer = null
      this.correctAnswer = null
      if (this.isTestingMode) {
        const answer = this.$_subsectionMixin_getAnswerCookies(this.test.id)
        if (answer) {
          document.getElementById('testInput').value = answer
        }
      } else if (this.isTestReviewMode) {
        const answer = this.$_subsectionMixin_getAnswerFromData(this.test, this.solvedByStudent)
        if (answer) {
          this.studentAnswer = answer
          this.correctAnswer = this.subsection.qstruct.answer
          document.getElementById('testInput').value = answer
        }
      }
    },
    sendAnswers() {
      if (!this.isTestingMode) {
        this.isTriedToAnswer = true
        this.sendAnswer({
          courseId: this.$route.params.courseBookId,
          subsectionId: this.$route.params.subsectionId,
          answer: document.getElementById('testInput').value,
          type: 'test'
        })
      } else {
        this.$cookies.set(`test_${this.$route.params.sectionId}_${this.$route.params.subsectionId}_flash`, document.getElementById('testInput').value)
        const questions = this.$cookies.keys().filter((k) => k.includes(`test_${this.test.id}`))
        this.$_subsectionMixin_updateSolved(questions)
      }
    },
    ...mapMutations({
      setSubsectionAnswer: 'education/setSubsectionAnswer'
    }),
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater',
      sendAnswer: 'education/sendAnswer'
    }),
    onAnswersChange() {
      this.updateUpdater()
      const answer = document.getElementById('testInput').value
      this.setSubsectionAnswer(answer)
      document.getElementById('answers-for-flash').value = this.subsection.qstruct.answer
    },
    addFlash() {
      this.currentFlash = (this.subsection) ? this.subsection.file : null
      this.currentUrl = this.$route.path
      this.$bvModal.show('files-upload-modal')
    }
  }
}
</script>

<style scoped>
  .flash-object object{
    height: 300px;
  }
</style>
